var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFire2 = function SvgIconFire2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 64 64"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#C2A2FF",
    filter: "url(#icon_fire2_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32.003,
    cy: 8.87,
    r: 4.87
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 32.003,
    cy: 55.13,
    r: 4.87
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 55.131,
    cy: 32,
    r: 4.87,
    transform: "rotate(90 55.131 32)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 8.87,
    cy: 32,
    r: 4.87,
    transform: "rotate(90 8.87 32)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 48.364,
    cy: 48.356,
    r: 4.87,
    transform: "rotate(135 48.364 48.356)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.653,
    cy: 15.645,
    r: 4.87,
    transform: "rotate(135 15.653 15.645)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.87,
    cy: 4.87,
    r: 4.87,
    transform: "scale(1 -1)rotate(-45 -53.993 -34.746)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.87,
    cy: 4.87,
    r: 4.87,
    transform: "scale(1 -1)rotate(-45 1.85 -57.875)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon_fire2_svg__a",
    width: 64.001,
    height: 64,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.760784 0 0 0 0 0.635294 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_272_76125"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_272_76125",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "effect2_foregroundBlur_272_76125",
    stdDeviation: 2
  })))));
};
export default SvgIconFire2;